import credentials from './credentials.json'
const AWS = require('aws-sdk');

AWS.config.update(credentials);


export const sendEmail = (email) => {

    var params = {
        Destination: {
            ToAddresses: [
                ...email.to
            ],
            CcAddresses: [
                ...email.cc
            ]
        },
        Source: email.from,
        Template: email.template,
        TemplateData: email.templatedData,
        ReplyToAddresses: [
            ...email.replyTo
        ],
    };

    return new AWS.SES({ apiVersion: '2010-12-01' }).sendTemplatedEmail(params).promise();



};
